<template>
  <div class="bloco-divisao">
    <div>
      <div class="imposto-nome">ICMS</div>
      <div class="icms-container-todos">
        <p-check class="p-switch" name="switchPis" color="primary" v-model="selecionarTodos"
          ><div class="icms-check">Selecionar todas as UFs</div></p-check
        >
      </div>
      <div class="icms-sessao">
        <div class="icms-container" v-for="(item, index) in estados" :key="index">
          <input :ref="`check${item.sigla}`" type="checkbox" v-model="item.check" />
          <div @click="clickInput(`check${item.sigla}`)" class="icms-check">{{ item.sigla }}</div>
        </div>
      </div>
    </div>

    <div class="tributos-container">
      <div class="produtos-check-impostos">
        <div v-for="(item, index) in impostos" :key="index" class="produtos-check-container">
          <p-check class="p-switch" name="switchPis" color="primary" v-model="item.check"
            ><div class="imposto-nome">{{ item.label }}</div></p-check
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalMonitoramentoProduto",
  props: {
    arTributos: Array,
    icmsEstado: Array
  },
  data() {
    return {
      selecionaIcms: [],
      atualizando: false,
      selecionarTodos: false,
      impostos: [
        { label: "PIS/COFINS", check: false },
        { label: "CIDE Combustíveis", check: false },
        { label: "IPI", check: false },
        { label: "Imposto de Importação", check: false },
        { label: "Imposto de Exportação", check: false },
        { label: "Defesa Comercial", check: false },
        { label: "Acordos Internacionais", check: false }
      ],
      estados: [
        {
          id_estado: "1",
          sigla: "AC",
          estado: "Acre",
          check: false
        },
        {
          id_estado: "2",
          sigla: "AL",
          estado: "Alagoas",
          check: false
        },
        {
          id_estado: "3",
          sigla: "AM",
          estado: "Amazonas",
          check: false
        },
        {
          id_estado: "4",
          sigla: "AP",
          estado: "Amapá",
          check: false
        },
        {
          id_estado: "5",
          sigla: "BA",
          estado: "Bahia",
          check: false
        },
        {
          id_estado: "6",
          sigla: "CE",
          estado: "Ceará",
          check: false
        },
        {
          id_estado: "7",
          sigla: "DF",
          estado: "Distrito Federal",
          check: false
        },
        {
          id_estado: "8",
          sigla: "ES",
          estado: "Espírito Santo",
          check: false
        },
        {
          id_estado: "9",
          sigla: "GO",
          estado: "Goiás",
          check: false
        },
        {
          id_estado: "10",
          sigla: "MA",
          estado: "Maranhão",
          check: false
        },
        {
          id_estado: "11",
          sigla: "MG",
          estado: "Minas Gerais",
          check: false
        },
        {
          id_estado: "12",
          sigla: "MS",
          estado: "Mato Grosso do Sul",
          check: false
        },
        {
          id_estado: "13",
          sigla: "MT",
          estado: "Mato Grosso",
          check: false
        },
        {
          id_estado: "14",
          sigla: "PA",
          estado: "Pará",
          check: false
        },
        {
          id_estado: "15",
          sigla: "PB",
          estado: "Paraíba",
          check: false
        },
        {
          id_estado: "16",
          sigla: "PE",
          estado: "Pernambuco",
          check: false
        },
        {
          id_estado: "17",
          sigla: "PI",
          estado: "Piauí",
          check: false
        },
        {
          id_estado: "18",
          sigla: "PR",
          estado: "Paraná",
          check: false
        },
        {
          id_estado: "19",
          sigla: "RJ",
          estado: "Rio de Janeiro",
          check: false
        },
        {
          id_estado: "20",
          sigla: "RN",
          estado: "Rio Grande do Norte",
          check: false
        },
        {
          id_estado: "21",
          sigla: "RO",
          estado: "Rondônia",
          check: false
        },
        {
          id_estado: "22",
          sigla: "RR",
          estado: "Roraima",
          check: false
        },
        {
          id_estado: "23",
          sigla: "RS",
          estado: "Rio Grande do Sul",
          check: false
        },
        {
          id_estado: "24",
          sigla: "SC",
          estado: "Santa Catarina",
          check: false
        },
        {
          id_estado: "25",
          sigla: "SE",
          estado: "Sergipe",
          check: false
        },
        {
          id_estado: "26",
          sigla: "SP",
          estado: "São Paulo",
          check: false
        },
        {
          id_estado: "27",
          sigla: "TO",
          estado: "Tocantins",
          check: false
        }
      ]
    };
  },
  created() {
    this.atualizaTributos();
    this.atualizaEstados();
  },
  watch: {
    estados: {
      deep: true,
      handler() {
        let selecionado = this.estados.map(p => p.check);
        if (selecionado.every(p => p == true)) {
          this.selecionarTodos = true;
        } else if (selecionado.some(p => p == false)) {
          this.selecionarTodos = false;
        }
        if (this.atualizando == false) {
          this.selecionaIcms = this.estados.filter(f => f.check == true).map(p => p.id_estado);
        }
      }
    },
    selecionaIcms(newVal, oldVal) {
      if (this.atualizando == false && JSON.stringify(newVal) != JSON.stringify(oldVal)) {
        this.$emit("icms", this.selecionaIcms);
      }
    },
    impostos: {
      deep: true,
      handler() {
        this.$emit("impostos", this.selecionaImposto);
      }
    },
    selecionarTodos() {
      let selecionado = this.estados.map(p => p.check);
      if (this.selecionarTodos) {
        this.estados.forEach(e => this.$set(e, "check", true));
      } else if (selecionado.every(p => p == true)) {
        this.estados.forEach(e => this.$set(e, "check", false));
      }
    },
    arTributos: {
      deep: true,
      handler() {
        this.atualizaTributos();
      }
    },
    icmsEstado: {
      deep: true,
      handler() {
        this.atualizaEstados();
      }
    }
  },
  computed: {
    selecionaImposto() {
      let imposto = [
        "",
        "",
        this.impostos.find(f => f.label == "PIS/COFINS").check,
        this.impostos.find(f => f.label == "CIDE Combustíveis").check,
        this.impostos.find(f => f.label == "IPI").check,
        this.impostos.find(f => f.label == "Imposto de Importação").check,
        this.impostos.find(f => f.label == "Imposto de Exportação").check,
        this.impostos.find(f => f.label == "Defesa Comercial").check,
        false,
        false,
        false,
        false,
        this.impostos.find(f => f.label == "Acordos Internacionais").check
      ];
      return imposto;
    }
  },
  methods: {
    atualizaTributos() {
      this.impostos.find(f => f.label == "PIS/COFINS").check = this.arTributos[2];
      this.impostos.find(f => f.label == "CIDE Combustíveis").check = this.arTributos[3];
      this.impostos.find(f => f.label == "IPI").check = this.arTributos[4];
      this.impostos.find(f => f.label == "Imposto de Importação").check = this.arTributos[5];
      this.impostos.find(f => f.label == "Imposto de Exportação").check = this.arTributos[6];
      this.impostos.find(f => f.label == "Defesa Comercial").check = this.arTributos[7];
      this.impostos.find(f => f.label == "Acordos Internacionais").check = this.arTributos[12];
    },
    atualizaEstados() {
      this.atualizando = true;
      this.estados.forEach(e => this.$set(e, "check", false));
      if (this.icmsEstado && this.icmsEstado.length > 0) {
        this.icmsEstado.forEach(e => {
          this.estados.find(f => f.id_estado == e).check = true;
        });
      }
      this.atualizando = false;
    },
    clickInput(ref) {
      this.$refs[ref][0].click();
    }
  }
};
</script>

<style lang="scss" scoped>
.bloco-divisao {
  display: grid;
  grid-template-columns: 2fr 3fr;
  width: 100%;
  gap: 10px 10px;
}
.produtos-check-impostos {
  padding: 20px 0;
  display: grid;
  height: 100%;
  grid-template-columns: 1fr 1fr;
}
.produtos-check-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  margin: 0 0 20px 10px;
  padding-right: 10px;
}
.tributos-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px 0 15px;
  border-left: 1px solid var(--cinza03);
}
.icms-check {
  display: flex;
  justify-content: center;
  width: fit-content;
  padding-left: 5px;
}
.icms-container {
  padding-left: 10px;
  width: 60px;
  height: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  user-select: none;
  input {
    cursor: pointer;
    height: 15px;
    width: 15px;
  }
}
.icms-container-todos {
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 10px;
  input {
    height: 15px;
    width: 15px;
  }
  div {
    width: fit-content;
    margin-left: 5px;
  }
}
.icms-sessao {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  height: 150px;
}
.imposto-nome {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 13px;
  text-transform: uppercase;
  color: #9ea2a7;
}
.p-switch {
  font-size: 13px !important;
}
</style>
